import { Navigate, RouteObject } from 'react-router-dom';
import { ForgeLayout } from './components/layout/ForgeLayout';
import { RecognitionReviewToolPage } from './pages/admin/RecognitionReviewToolPage';
import { RemoteDataCollectionConfiguration } from './pages/configuration/RemoteDataCollectionConfiguration';
import { CleaningTasksDashboard } from './pages/dashboard/CleaningTasksDashboard';
import { DataCollectionDashboard } from './pages/dashboard/DataCollectionDashboard';
import { DesignGroupsDashboard } from './pages/dashboard/DesignGroupsDashboard';
import { DesignsDashboard } from './pages/dashboard/DesignsDashboard';
import { LockedDesignsDashboard } from './pages/dashboard/LockedDesignsDashboard';
import { MasterLabelUnresolvedDashboard } from './pages/dashboard/MasterLabelUnresolvedDashboard';
import { ProductRecognitionInferenceDashboard } from './pages/dashboard/ProductRecognitionInferenceDashboard';
import { RecognitionOkrsDashboard } from './pages/dashboard/RecognitionOkrsDashboard';
import { RemoteDataCollectionDashboard } from './pages/dashboard/RemoteDataCollectionDashboard';
import { ReportedIssuesDashboard } from './pages/dashboard/ReportedIssuesDashboard';
import { ReviewIssuesDashboard } from './pages/dashboard/ReviewIssuesDashboard';
import { SaveWarningsDashboard } from './pages/dashboard/SaveWarningsDashboard';
import { SystemHealthDashboard } from './pages/dashboard/SystemHealthDashboard';
import { VizSimDatasetsDashboard } from './pages/dashboard/VizSimDatasetsDashboard';
import { FORGE_SYSTEM_HEALTH_PATH } from './paths';

export const forgeRoutes: RouteObject = {
  path: '/forge',
  element: <ForgeLayout />,
  children: [
    { index: true, element: <Navigate to={FORGE_SYSTEM_HEALTH_PATH} replace /> },
    // Dashboards
    {
      path: 'dashboards/system-health',
      element: <SystemHealthDashboard />,
    },
    {
      path: 'dashboards/reported-issues',
      element: <ReportedIssuesDashboard />,
    },
    {
      path: 'dashboards/pr-inference-okrs',
      element: <ProductRecognitionInferenceDashboard />,
    },
    {
      path: 'dashboards/recognition-okrs',
      element: <RecognitionOkrsDashboard />,
    },
    {
      path: 'dashboards/designs',
      element: <DesignsDashboard />,
    },
    {
      path: 'dashboards/design-groups',
      element: <DesignGroupsDashboard />,
    },
    {
      path: 'dashboards/locked-designs',
      element: <LockedDesignsDashboard />,
    },
    {
      path: 'dashboards/vizsim-datasets',
      element: <VizSimDatasetsDashboard />,
    },
    {
      path: 'dashboards/save-warnings',
      element: <SaveWarningsDashboard />,
    },
    // Task lists
    { path: 'task-lists/store-dc', element: <DataCollectionDashboard /> },
    { path: 'task-lists/remote-dc', element: <RemoteDataCollectionDashboard /> },
    { path: 'task-lists/review-issues', element: <ReviewIssuesDashboard /> },
    { path: 'task-lists/unresolved', element: <MasterLabelUnresolvedDashboard /> },
    { path: 'task-lists/cleaning', element: <CleaningTasksDashboard /> },
    // Configuration
    { path: 'configuration/remote-dc', element: <RemoteDataCollectionConfiguration /> },
    // Labeling tools
    // Other labeler-accessible tool routes are registered at top level in App.tsx; the Recognition
    // review tool is admin-only, so it lives here and inherits the Forge ProtectedRoute guard.
    { path: 'labeling-tools/recognition-review', element: <RecognitionReviewToolPage /> },
  ],
};
